import React from 'react';
import { Box, Link, TextField, InputAdornment } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Arrow from '../../assets/Arrow.svg'
import Search from '../../assets/search.svg'
import CaretLeft from '../../assets/CaretLeft.svg'

const ResponsiveNav = ({ breadcrumbItems, searchValue, onSearchChange, searchPlaceholder }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm')); 

  return (
    <Box sx={{ width: '100%', padding: '16px', borderRadius: '10px', fontFamily: theme=> theme.typography.smallText }}>
      <Box sx={{ display: 'flex', flexDirection: isDesktop ? 'row' : 'column', alignItems: 'center', justifyContent: 'space-between' }}>
            
        {/* Conditional Rendering for Breadcrumb and Links */}
        {isDesktop ? (
          // Desktop View: Horizontal Breadcrumb and Search
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Link component={RouterLink} to="/" sx={{ color: '#929294', display: 'flex', alignItems: 'center', textDecoration:'none' }}>
              <HomeIcon sx={{ color: '#929294', fontSize: 20 }} />
            </Link>

            {/* Render breadcrumb items dynamically with arrows */}
            {breadcrumbItems.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <img src={Arrow} alt="Arrow" style={{ width: 15, height: 15, margin: '0 8px' }} />
                )}
                
                <Link
                  component={RouterLink}
                  to={item.link}
                  sx={{
                    color: index === breadcrumbItems.length - 1 ? '#27252B' : '#929294', // Highlight last breadcrumb
                    fontWeight: index === breadcrumbItems.length - 1 ? 500 : 400,
                    textDecoration:'none',
                    '&:hover': {
                        color: '#27252B', // Change color on hover (you can adjust the color as needed)
                        fontWeight: 500,   // Make the font weight bold on hover (optional)
                      },
                
                  }}
                >
                  {item.label}
                </Link>
              </React.Fragment>
            ))}
          </Box>
        ) : (
          // Mobile View: Stacked Breadcrumb and Search
          <Box sx={{ alignSelf: 'flex-start', marginBottom: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img src={CaretLeft} alt="Arrow" style={{ width: 15, height: 15 }} />
              <Link to="/" style={{ color: '#929294', textDecoration: 'none', cursor: 'pointer' }}>
                Go Home
              </Link>
            </Box>
          </Box>
        )}
        {/* Search bar */}
        <TextField
          variant="outlined"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={onSearchChange}
          sx={{
            width: '100%',
            maxWidth: 380,
            marginTop: isDesktop ? 0 : 2,
            '& .MuiOutlinedInput-root': {
              borderRadius: '15px',
              height: 40
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img src={Search} alt="Search" style={{ width: 20, height: 20 }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Box>
  );
};

export default ResponsiveNav;
